// extracted by mini-css-extract-plugin
export default {"timeSlotColumn":"TimeSlotsList_timeSlotColumn__mg3Ht","timeSlotTitle":"TimeSlotsList_timeSlotTitle__S1bYx","timeSlotWrapper":"TimeSlotsList_timeSlotWrapper__hkmqu"};